require('./dropdownButton.tpl.html');
require('./dropdownButtonController');

const DropdownButtonComponent = {
    templateUrl: '/ui/dropdown/common/button/dropdownButton.tpl.html',
    controller: 'umDropdownButtonController',
    bindings: {
        displayText: '<',
        statusText: '<',
        tooltipText: '<',
        tooltipEnabled: '<',
        enabled: '<',
        valid: '<',
        hasBusinessCard: '<',
        businessCardUserId: '<',
        businessCardOrganizationId: '<',
        onClick: '&',
        tooltipMessage: '<'
    }
};

angular.module('umCore')
    .component('umDropdownButton', DropdownButtonComponent);
